import {useRef, useState} from 'react'
import {GoogleMap, useJsApiLoader} from '@react-google-maps/api'
import {Layout, usePageContext} from '~/components'
import {getGoogleMapConfig} from './map_config'
import {useMarkers, useSearch, useGroupedEnvironments} from './hooks'
import {t} from '~/initializers/i18n'
import './styles/map.less'

const NETHERLANDS_CENTER = {lat: 52.05, lng: 5.279}
const INITIAL_ZOOM = 8
const GMAPS_API_KEY = import.meta.env.VITE_GMAPS_API_KEY

export const Map = () => {
	const {showLabels} = usePageContext()
	const {isLoaded} = useJsApiLoader({googleMapsApiKey: GMAPS_API_KEY, libraries: ['places']})
	const [mapInstance, setMapInstance] = useState(null)
	const mapConfig = getGoogleMapConfig(showLabels)
	const searchInputRef = useRef(null)

	const groupedEnvironments = useGroupedEnvironments()
	useMarkers({isLoaded, mapInstance, groupedEnvironments})
	useSearch({isLoaded, mapInstance, searchInputRef})

	if (!isLoaded) return null

	return (
		<Layout className="map" width="full" height="full">
			<Layout absolute="16 16 - -" className="map-search">
				<input ref={searchInputRef} className="map-input" placeholder={t('placeholders.map.search.placeholder')} />
			</Layout>

			<GoogleMap
				mapContainerClassName="map-container"
				center={NETHERLANDS_CENTER}
				zoom={INITIAL_ZOOM}
				options={{gestureHandling: 'greedy', disableDefaultUI: true, styles: mapConfig}}
				onLoad={setMapInstance}
				onUnmount={() => setMapInstance(null)}
			/>
		</Layout>
	)
}
